export default "__VITE_ASSET__x7jBi41P__"